const BASE_URL = process.env.VUE_APP_JAVA_BASE_URL

import Service from "@/services";
import InGameShopData from "@/components/game_shop/shop";
import { SHOP_ITEM_TYPES, SHOP_COMMIT_NAMES } from "@/utils/shopItemTypes";
import {encryptionMixin} from "@/mixins/encryptionMixin";


export default {
    namespaced: true,
    state: {
        itemsLoading: true,
        bundles: [],
        frames: [],
        wheels: [],
        head: [],
        hair: [],
        glasses: [],
        jerseys: [],
        shoes: [],
        socks: [],
        helmet: [],
        gloves: [],
        facialHair: [],
        gems_bundles: [],
        coins_bundles: [],
    },
    getters: {
        itemsLoading: (state) => state.itemsLoading,
        bundles: (state) => state.bundles,
        frames: (state) => state.frames,
        wheels: (state) => state.wheels,
        head: (state) => state.head,
        hair: (state) => state.hair,
        socks: (state) => state.socks,
        shoes: (state) => state.shoes,
        helmet: (state) => state.helmet,
        gloves: (state) => state.gloves,
        jerseys: (state) => state.jerseys,
        glasses: (state) => state.glasses,
        facialHair: (state) => state.facialHair,
        gems_bundles: (state) => state.gems_bundles,
        coins_bundles: (state) => state.coins_bundles,
    },
    actions: {

        // eslint-disable-next-line no-unused-vars
        async getRedirectUrl({ commit }, payload) {
            try {
                return await Service().post(
                    "../api/garage/redirect-to-checkout",
                    payload
                )
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                return [];
            }
        },

        async getAllGarageItems({ commit }) {
            commit("SET_ITEMS_LOADING", true);

             try {
                 const response = await Service().get(BASE_URL + "v1/economy/garage/item?unlockType=Purchasable");

                 const garage_items = response['MyWhooshShopItemsMetaData'] ?? [];

                const addDetails = (item, entry) => ({
                    ...item,
                    Description: entry.description,
                    Aerodynamics: entry.aerodynamics,
                    Weight: entry.weight ?? null,
                    thumbnail: entry.thumbnail,
                    Name: entry.name
                });

                SHOP_ITEM_TYPES.forEach(({ type, key, commit_name }) => {
                    const entries = InGameShopData[key] ?? [];
                    const items = garage_items
                        .filter(item => item.Type == type)
                        .map(item => {
                            const entry = entries.find(shopItem => shopItem.id == item.Id);
                            if (!entry || item.UnlockValue == 0 || item.CurrencyType != 0) {
                                return null;
                            }
                            return addDetails(item, entry);
                        })
                        .filter(Boolean);
                    commit(commit_name, items);
                });

                return true; // Success indicator
            } catch (error) {
                 console.error(error)

                // Commit empty arrays for fallback commit types
                SHOP_COMMIT_NAMES.forEach(commitType => commit(commitType, []));

                return error; // Error indicator
            } finally {
                commit("SET_ITEMS_LOADING", false);
            }
        },
        async getBundleInfo({ commit }) {
            try {

                const response = await Service().get(BASE_URL + "v1/economy/bundle/info");
                const bundle_info = response.MyWhooshShopBundlesData ?? [];

                if (bundle_info.length === 0) {
                    console.warn("No bundle information found.");
                    commit("SET_GEMS_BUNDLE", []);
                    commit("SET_COINS_BUNDLE", []);
                    return false; // Indicate that no bundles were found
                }

                const filterAndSortBundles = (type) => {
                    return bundle_info
                        .filter(item => item.Platform == "IOS" && item.Type == type && item.BundleType == "economy")
                        .sort((a, b) => a.Reward - b.Reward);
                };

                const gems_bundles = filterAndSortBundles("gems");
                const coins_bundles = filterAndSortBundles("coins");

                commit("SET_GEMS_BUNDLE", gems_bundles);
                commit("SET_COINS_BUNDLE", coins_bundles);

                return true;
            } catch (e) {
                console.error("Error fetching bundle info:", e);
                return e;
            }
        } ,
        // eslint-disable-next-line no-unused-vars
        async getPaymentInfo({ commit }, payload) {
            try {
                return await Service().post(
                    "../api/garage/payment/info",
                    payload
                );
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                return [];
            }
        },
        // eslint-disable-next-line no-unused-vars
        async purchaseGems({ commit }, payload) {
            try {
                return await Service().post(
                    "../api/garage/purchase/gems",
                    payload
                );
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                return [];
            }
        },
        // eslint-disable-next-line no-unused-vars
        async purchaseItem({ commit }, payload) {
            try {
                const payloadEnc = JSON.stringify(payload);
                const encryptedPayload = encryptionMixin.methods.encrypt(payloadEnc);

                return await Service().post(
                    "../api/garage/purchase/item",
                    {payload:encryptedPayload}
                );
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                return [];
            }
        },
        // eslint-disable-next-line no-unused-vars
        async checkUserPurchaseItem({ commit }, payload) {
            try {

             const payloadEnc = JSON.stringify(payload);
               const encryptedPayload = encryptionMixin.methods.encrypt(payloadEnc);

                return await Service().post(
                    "../api/garage/check-user-purchase-item",
                    {payload:encryptedPayload}
                );
                // eslint-disable-next-line no-unreachable
            } catch (e) {
                console.error(e)
                return [];
            }
        },
    },
    mutations: {
        SET_ITEMS_LOADING: (state, payload) => (state.itemsLoading = payload),
        SET_BUNDLES: (state, payload) => (state.bundles = payload),
        SET_FRAMES: (state, payload) => (state.frames = payload),
        SET_WHEELS: (state, payload) => (state.wheels = payload),
        SET_HEAD: (state, payload) => (state.head = payload),
        SET_HAIR: (state, payload) => (state.hair = payload),
        SET_FACIALHAIR: (state, payload) => (state.facialHair = payload),
        SET_GEMS_BUNDLE: (state, payload) => (state.gems_bundles = payload),
        SET_COINS_BUNDLE: (state, payload) => (state.coins_bundles = payload),
        SET_JERSEYS: (state, payload) => (state.jerseys = payload),
        SET_GLOVES: (state, payload) => (state.gloves = payload),
        SET_HELMET: (state, payload) => (state.helmet = payload),
        SET_SHOES: (state, payload) => (state.shoes = payload),
        SET_SOCKS: (state, payload) => (state.socks = payload),
        SET_GLASSES: (state, payload) => (state.glasses = payload),
    },
};
